import React from "react";
import moment from "moment";
import ReactSelect, { components } from "react-select";
import classnames from "classnames";
import loadImage from "blueimp-load-image";
import DateTimePicker from "../DateTimePicker";
import TimePicker from "../TimePicker";
import Firebase from "../../firebasehelper";
import "./index.css";
import MediaSelect from "../MediaSelect";
import RadioItem from "../RadioItem";

class NewPoll extends React.Component {
  state = {
    answers: [
      {
        text: "",
        icon: "",
      },
      {
        text: "",
        icon: "",
      },
    ],
    postNow: true,
    scheduledDate: moment(new Date()),
    uploading: false,
    hot_topic_tags: [],
    hot_topic: null,
    toMembers: true,
    toReferrals: true,
  };
  componentDidMount() {
    const { brand_name } = this.props;
    if (brand_name)
      Firebase.getAllHotTopics(brand_name, (hot_topics) => {
        let hot_topic_tags = hot_topics.map((topic) => {
          let label = `${topic.starting_monday
            .toDate()
            .toLocaleDateString("en-US", {
              month: "long",
              day: "numeric",
            })} - ${topic.tag}`;
          let value = topic.id;
          return { label, value };
        });
        this.setState({ hot_topic_tags });
      });
    else {
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.selectedDate !== this.props.selectedDate) {
      this.setState({ postNow: true }, () => {
        this.setState({
          postNow: false,
          scheduledDate: this.props.selectedDate,
        });
      });

      const { brand_name } = this.props;
      if (brand_name)
        Firebase.getAllHotTopics(brand_name, (hot_topics) => {
          let hot_topic_tags = hot_topics.map((topic) => {
            let label = `${topic.starting_monday
              .toDate()
              .toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
              })} - ${topic.tag}`;
            let value = topic.id;
            return { label, value };
          });
          this.setState({ hot_topic_tags });
        });
    }
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  onChangeScheduledDate = (value) => {
    this.setState({
      scheduledDate: value,
    });
  };
  onChangeTime = (obj) => {
    const { scheduledDate } = this.state;
    const { hh, mm, of } = obj;
    let hours = hh;
    let newMoment = moment(scheduledDate);
    if (of === "pm" && hh !== 12) hours = hh + 12;
    newMoment.set("hour", hours);
    newMoment.set("minute", mm);
    this.setState({ scheduledDate: newMoment });
  };
  onAddAnswer = () => {
    const { answers } = this.state;

    if (answers.length >= 12) {
      return;
    }

    this.setState({
      answers: [
        ...answers,
        {
          text: "",
          icon: "",
        },
      ],
    });
  };

  onChangeAnswer = (index) => (e) => {
    const { answers } = this.state;
    answers[index].text = e.target.value;

    this.setState({
      answers: [...answers],
    });
  };

  onRemoveAnswer = (index) => () => {
    const { answers } = this.state;
    answers.splice(index, 1);
    this.setState({
      answers: [...answers],
    });
  };

  handlePostNowChanged = (value) => () => {
    this.setState({
      postNow: value,
    });
  };

  handleMediaChanged = (type, url) => {
    this.setState({ media_type: type, media_url: url });
  };
  // openPollImage = () => {
  //   const pollImageElm = document.getElementById("quiz_img");
  //   if (pollImageElm) {
  //     pollImageElm.click();
  //   }
  // };

  isPostable = () => {
    const {
      question,
      answers,
      media_type,
      media_url,
      scheduledDate,
      hot_topic,
      postNow,
    } = this.state;
    const timeValuable = postNow
      ? true
      : scheduledDate.isAfter(moment(new Date()));
    const isPostable =
      question &&
      media_type &&
      media_url &&
      !answers.find((answer) => !answer.text) &&
      timeValuable;

    return isPostable;
  };
  // selectedFile = (e) => {
  //   let _this = this;
  //   let id = e.target.id;
  //   if (e.target.files && e.target.files[0]) {
  //     var content = e.target.files[0];
  //     loadImage.parseMetaData(content, function (data) {
  //       //default image orientation
  //       var orientation = 0;
  //       if (data.exif) {
  //         orientation = data.exif.get("Orientation");
  //       }
  //       loadImage(
  //         content,
  //         function (canvas) {
  //           var base64data = canvas.toDataURL("image/png");
  //           var img_src = base64data.replace(/^data\:image\/\w+\;base64\,/, "");
  //           _this.setState({ [id]: img_src });
  //         },
  //         {
  //           canvas: true,
  //           orientation: orientation,
  //         }
  //       );
  //     });
  //     this.setState({ question_img: URL.createObjectURL(e.target.files[0]) });
  //   }
  // };

  post = async () => {
    const {
      question,
      answers,
      // quiz_img,
      media_type,
      media_url,
      postNow,
      scheduledDate,
      hot_topic,
      toMembers,
      toReferrals,
    } = this.state;
    this.setState({ uploading: true });
    try {
      if (this.props.onAdd) {
        let error = await this.props.onAdd({
          question,
          answers,
          // quiz_img,
          media_type,
          media_url,
          hot_topic: hot_topic ? hot_topic.value : null,
          postNow: this.props.selectedDate ? false : postNow,
          scheduledDate: scheduledDate,
          toMembers,
          toReferrals,
        });
        if (!error) {
          this.setState({
            question: "",
            // quiz_img: "",
            media_type: "",
            media_url: "",
            answers: [
              {
                text: "",
                icon: "",
              },
              {
                text: "",
                icon: "",
              },
            ],
            postNow: true,
            scheduledDate: moment(new Date()),
          });
        }
      }
    } catch (e) {
      console.log("adding poll error", e);
    }

    this.setState({ uploading: false });
  };

  render() {
    const {
      answers,
      brand_name,
      media_type,
      media_url,
      question,
      uploading,
      postNow,
      scheduledDate,
      hot_topic_tags,
      hot_topic,
      toMembers,
      toReferrals,
    } = this.state;

    const { selectedDate } = this.props;

    return (
      <div className="new-poll-container">
        <div className="left-side">
          <p className="section-title">Poll Topic</p>
          <input
            type="text"
            name="question"
            className="form-control form-control-lg form-control-alt"
            onChange={this.onChange}
            value={question}
            placeholder="Type your question here..."
          />
          <p className="section-title">Poll Media</p>
          <MediaSelect
            uploadFoler={`polls/${brand_name}`}
            onChangeContent={this.handleMediaChanged}
          />
          {/* <button
            className="btn btn-hero-lg btn-hero-success poll-image-btn"
            onClick={this.openPollImage}
          >
            Choose Image
          </button> */}
          {/* <input
            type="file"
            id="quiz_img"
            name="logo-file-input"
            accept="image/*"
            onChange={this.selectedFile}
            style={{ display: "none" }}
          /> */}
          {answers.map(({ icon, text }, index) => (
            <div className="option" key={index}>
              <div className="answer-title">
                <p className="section-title">Answer {index + 1}</p>
                {answers.length > 2 && (
                  <i
                    className="far fa-times-circle"
                    onClick={this.onRemoveAnswer(index)}
                  ></i>
                )}
              </div>
              <input
                type="text"
                className="form-control form-control-lg form-control-alt"
                value={text}
                onChange={this.onChangeAnswer(index)}
                placeholder={`Type your answer ${index + 1}...`}
              />
            </div>
          ))}
          <button className="btn btn-secondary post" onClick={this.onAddAnswer}>
            Add another poll answer
          </button>
          <div className="user-access-categories">
            <p>Post to user access categories</p>
            <RadioItem
              menuName="Members"
              checked={toMembers}
              onYes={() => {
                this.setState({ toMembers: true });
              }}
              onNo={() => {
                this.setState({ toMembers: false });
              }}
            />
            <RadioItem
              menuName="Prospect"
              checked={toReferrals}
              onYes={() => {
                this.setState({ toReferrals: true });
              }}
              onNo={() => {
                this.setState({ toReferrals: false });
              }}
            />
          </div>
          {hot_topic_tags.length > 0 && (
            <div className="form-group" style={{ marginTop: 30, width: 500 }}>
              <ReactSelect
                isSearchable={true}
                value={hot_topic}
                onChange={(e) => {
                  const { label, value } = e;
                  this.setState({
                    hot_topic: { label, value },
                  });
                }}
                options={[{ label: "None", value: null }, ...hot_topic_tags]}
                placeholder="Select a hot topic tag"
                styles={{
                  option: (provided, state) => ({
                    ...provided,
                    textAlign: "left",
                  }),
                }}
              ></ReactSelect>
            </div>
          )}
          <p className="schedule-title">
            {!selectedDate && (
              <React.Fragment>
                <b>Post now</b> or{" "}
              </React.Fragment>
            )}
            <b>Schedule</b>
          </p>
          {!selectedDate && (
            <div className="schdule-now-container">
              <div
                className={classnames("check-box", {
                  checked: postNow,
                })}
                onClick={this.handlePostNowChanged(true)}
                style={{
                  marginLeft: "20px",
                }}
              ></div>
              <div
                className={classnames("check-box", {
                  checked: !postNow,
                })}
                onClick={this.handlePostNowChanged(false)}
                style={{
                  marginLeft: "80px",
                }}
              ></div>
            </div>
          )}
          {/* {!postNow && (
            <Datetime
              initialValue={this.props.selectedDate || moment()}
              initialViewMode={selectedDate ? "time" : "days"}
              onChange={this.onChangeScheduledDate}
              inputProps={{
                className:
                  "form-control form-control-lg form-control-alt date-input",
              }}
              dateFormat="DD/MM/YYYY"
            />
          )} */}
          {!postNow && !this.props.selectedDate && (
            <DateTimePicker onTimeChange={this.onChangeScheduledDate} />
          )}
          {this.props.selectedDate && (
            <React.Fragment>
              <p className="feed-schedule-time">
                {this.state.scheduledDate.format("LLL")}
              </p>
              <TimePicker onChange={this.onChangeTime} />
            </React.Fragment>
          )}
          {uploading && <i className="fa fa-4x fa-sync fa-spin text-muted" />}
          {!uploading && (
            <button
              className="btn btn-green post "
              disabled={!this.isPostable()}
              onClick={this.post}
            >
              Post
            </button>
          )}
        </div>
        <div className="right-side">
          <div
            className="image-area"
            style={
              media_url
                ? {
                    backgroundImage: `url(${media_url})`,
                  }
                : {}
            }
          ></div>
        </div>
      </div>
    );
  }
}

export default NewPoll;



// WEBPACK FOOTER //
// ./src/components/NewPoll/index.js